module.exports = __webpack_public_path__ + "f42362bee85c7979675e3fc3f0d98f59.svg";